import { Component } from '@angular/core';
import { NavController, LoadingController, Events } from 'ionic-angular';

import { Form } from '../../../providers/survey';

import { FormPageDynamic, ListFormResponsePageDynamic } from '../';
import { UserMyRadiant as User } from '../../../providers';


import { TabsPage } from '@pages/dashboard';

@Component({
  selector: 'page-list-form',
  templateUrl: 'index.html'
})
export class ListFormPage {

  list_form  : any= [];
  total_data : any;

  user_data  : any={};
  resp_data  : any=[];

  server_date = {};

  loading : any;

  constructor(
    public  navCtrl    : NavController,
    public  loadingCtrl: LoadingController,
    public  formApi    : Form,
    public userApi     : User,
    private events     : Events
  ) {
    this.user_data = this.userApi.data;
  }

  ionViewDidEnter(){
    this.getList();
  }

  showLoading(){
    this.loading = this.loadingCtrl.create({
      content : 'Please wait . . .'
    });
    this.loading.present();
  }
  doRefresh(refresher) {
    refresher.complete();
    this.getList();
  }

  getList(){
    this.showLoading();

    let params:any = {
      modul : 'dynamic_form'
    };
    this.formApi.get(params).subscribe((resp:any) => {
      console.log('getListForm =>',resp);
      if(resp.success){
        this.list_form  = resp.data;
        this.total_data = resp.total_rows;
      }

      // this.resp_data = [];
      // resp.data.forEach(form =>{
      //   if(form.id != 3 && form.id != 6){
      //     this.list_form.push(form)
      //   }
      //   this.getListResponses(form.id);
      // });
      console.log("resp_data => ", this.resp_data);

      this.loading.dismiss();
    },(err) => {
      console.log(err);
      this.loading.dismiss();
    });
  }

  getListResponses(form_id){
    // this.showLoading();

    let params = {
      user_id   : this.user_data.Employee_ID,
      form_id   : form_id,
      form_name : ''
    };

      this.formApi.getListResponse(params).subscribe((resp:any) => {
        
        this.resp_data.push(resp.data[0]);
        this.server_date = resp.date;
        console.log("Sever Date => ", this.server_date);
        
        // this.loading.dismiss();
      }, (err) => {
        
        // this.loading.dismiss();    
      });
  }

  toListResponse(item) {
    if(item.form_url_frame){
      this.navCtrl.push(FormPageDynamic, {
        form: item
      });
    }else{
      this.navCtrl.push(ListFormResponsePageDynamic, {
        form: item
      });
    }
  }

  toForm(form){
    this.navCtrl.push(FormPageDynamic, {
      form : form
    });
  }

  backMyRadiant(evt){
    this.navCtrl.setRoot(TabsPage,{tabIndex:1});
    this.events.publish('modul:myradiant');
  }

}



// WEBPACK FOOTER //
// ./src/pages/dynamic_form/list_form/index.ts